/* eslint-disable */
export default {
  infoMessageMins:
    'Enregistrement automatique du journal dans {delayTime} minutes...',
  infoMessageMin:
    'Enregistrement automatique du journal dans {delayTime} minute...',
  infoMessageSecs:
    'Enregistrement automatique du journal dans {delayTime} secondes...',
  infoMessageSec:
    'Enregistrement automatique du journal dans {delayTime} seconde...',
} as const;

// @key: @#@"infoMessageMins"@#@ @source: @#@"Auto-save log in {delayTime} minutes..."@#@
// @key: @#@"infoMessageMin"@#@ @source: @#@"Auto-save log in {delayTime} minute..."@#@
// @key: @#@"infoMessageSecs"@#@ @source: @#@"Auto-save log in {delayTime} seconds..."@#@
// @key: @#@"infoMessageSec"@#@ @source: @#@"Auto-save log in {delayTime} second..."@#@
